export default class Product {
    constructor(titles, tagLines, contents, additionalInfos, tags, categories, files, images, customFields, featuredImage, price, tax, sku, featured) {
        // {} instead of array to support stringify
        this.titles = titles;
        this.tagLines = tagLines;
        this.contents = contents;
        this.additionalInfos = additionalInfos;
        this.tags = tags;

        this.categories = categories;
        this.files = files;
        this.images = images;
        this.customFields = customFields;

        this.featuredImage = featuredImage;
        this.price = price;
        this.tax = tax;
        this.sku = sku;
        this.featured = featured;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.tagLines)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; }
        // for (const [key, value] of Object.entries(this.additionalInfos)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.tags)) { if(!value || !value.length) { result = false; break; }; }

        if(this.featured == undefined || this.featured == null)
        {
            this.featured = false;
        }

        if(result) result = this.categories && this.categories.length && this.featuredImage && this.price && this.tax && this.sku;
        return result;
    }
}